import { PROFILE_BASE_URL } from './profile';
import type { Translation } from './types';

export function appInstallUrl(referrerHandle?: string) {
  const base = `${PROFILE_BASE_URL}/register`;
  if (!referrerHandle) {
    return base;
  }
  return `${base}?ref=${encodeURIComponent(referrerHandle)}`;
}

export function buildAppInviteShareContent(
  options: {
    inviterName: string;
    inviterHandle?: string;
    friendName?: string;
  },
  t: Pick<Translation, 'inviteShareTitle' | 'inviteShareMessage' | 'inviteShareMessageNamed'>,
) {
  const url = appInstallUrl(options.inviterHandle);
  const title = t.inviteShareTitle;
  const message = options.friendName
    ? t.inviteShareMessageNamed
        .replace('{inviter}', options.inviterName)
        .replace('{friend}', options.friendName)
    : t.inviteShareMessage.replace('{name}', options.inviterName);

  return { title, message, url };
}
